<template>
  <div class="p-1 favorites-sider">
    <h4 class="mb-25 d-flex align-items-center">
      <span>{{ $t('twitter.favorites') }}</span>
    </h4>
    <p class="text-muted small mb-1">{{ $t('ia.assistants.pickMaximum') }}</p>

    <div class="favorites-container d-flex flex-column">
      <div
        v-for="slot in slots"
        :key="'slot-' + slot.index"
        class="mb-1 position-relative draggable-wrapper"
        :class="{ 'is-placeholder': slot.type === 'empty' }"
        :draggable="slot.type === 'fav'"
        @dragstart="slot.type ==='fav' && onDragStart($event, slot.index)"
        @dragover.prevent="slot.type ==='fav' && onDragOver($event, slot.index)"
        @drop.prevent="slot.type ==='fav' && onDrop($event, slot.index)"
      >
        <template v-if="slot.type === 'fav'">
          <AssistantCard
            :assistant="mapFavoriteToAssistant(slot.data)"
            :is_favorite_layout="false"
            :show_favorite_action="false"
            @card-click="$emit('favorite-click', slot.data)"
          />
        </template>
        <template v-else>
          <AssistantCard
            :is_favorite_layout="true"
            @card-click="$emit('add-favorite-slot')"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'siderFavoritesAssistants',
  components: {
    AssistantCard: () => import('@/views/components/brandme-ai/cards/AssistantCard.vue'),
  },
  props: {
    favorites: {
      type: Array,
      default: () => []
    },
    all_assistants: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dragIndex: null,
    }
  },
  computed: {
    favoritesList() {
      return this.favorites
        .slice()
        .sort((a, b) => (a.order || 0) - (b.order || 0));
    },
    slots() {
      const arr = [];
      for (let i = 0; i < 3; i++) {
        if (i < this.favoritesList.length) {
          arr.push({ type: 'fav', data: this.favoritesList[i], index: i });
        } else {
          arr.push({ type: 'empty', index: i });
        }
      }
      return arr;
    },
  },
  methods: {
    mapFavoriteToAssistant(fav) {
      return this.all_assistants.find(a => a.slug === fav.slug) || {
        id: fav.slug,
        name: fav.name,
        description: '',
        avatar: 'assistant-email.png',
        tooltip: fav.name,
        isPro: false,
        isFavorite: true,
      }
    },
    onDragStart(e, index) {
      this.dragIndex = index;
      e.dataTransfer.effectAllowed = 'move';
    },
    onDragOver(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
    },
    onDrop(e, index) {
      if (this.dragIndex === null || this.dragIndex === index) return;
      const reordered = this.favoritesList.slice();
      const [moved] = reordered.splice(this.dragIndex, 1);
      reordered.splice(index, 0, moved);
      // Recalcular order
      const withOrder = reordered.map((f, idx) => ({ ...f, order: idx }));
      this.dragIndex = null;
      this.$emit('reorder-favorites', withOrder);
    }
  }
}
</script>

<style lang="scss" scoped>
.favorites-sider {
  .favorites-container {
    min-height: 120px;
  }

  .draggable-wrapper {
    cursor: grab;
    &:active { cursor: grabbing; }
    &.is-placeholder { cursor: default; }
  }

  .drag-handle {
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    color: #6c757d;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    pointer-events: none; // evita interferir con dragstart en wrapper
  }
}
</style>